import { FabricChannel } from '@atlaskit/analytics-listeners/types';
export var editorAnalyticsChannel = FabricChannel.editor;